import React, { createContext, ReactNode, useContext, useState } from "react";
import { initialFeatureFlags } from "@/config/featureFlags";
import { TFeatureFlags } from "@/interfaces";

const FeatureFlagsContext = createContext<TFeatureFlags>(initialFeatureFlags);

export const FeatureFlagsProvider = ({ children }: { children: ReactNode }) => {
  const [flags, setFlags] = useState(initialFeatureFlags);

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlagsContext = () => useContext(FeatureFlagsContext);
